import React from 'react';
import {handleCheckbox,handleRadio,handleSequence,autoFocusNext,allowOnlyNumberInput,countWords} from '../helpers/Fields';
const $ = window.$;


export default class Confidencemeter extends React.Component {

    constructor(props) {
        super(props);
    }

   
    render() {
        let dynamic_confidence=this.props;
        let confidence_result='';
        let coorectanswer='';
        /*let checked_one=false;
        let checked_two=false;
        let checked_three=false;*/
        let gobackanser=0;
        if(dynamic_confidence.goback_confanswer)
        {
            gobackanser=dynamic_confidence.goback_confanswer;
        }

        if(dynamic_confidence.confidence_result)
        {
            confidence_result=dynamic_confidence.confidence_result;
        }
        
        /*if(dynamic_confidence.correct_ans)
        {
           coorectanswer=dynamic_confidence.correct_ans;
           
           if(confidence_result===1)
           {
             checked_one=true;
             
           }
           else if(confidence_result===2)
           {
             checked_two=true;
           }
           else if(confidence_result===3)
           {
             checked_three=true;
           }
        }*/
        if(coorectanswer ==='' && confidence_result =='')
        {
        return (
            <div className="lr-gray-box test">
                <h4>How confident are you about this answer ?</h4> 
               {gobackanser==1 ?
                <div className="ca_releas4">
               <input type="radio" className="not_sure" id={`notsure_${dynamic_confidence.dynamic_confidence}`} name={`confidence_${dynamic_confidence.dynamic_confidence}`} value="1" checked /> <b> Not sure </b>
               </div> : <div className="ca_releas4">
               <input type="radio" className="not_sure" id={`notsure_${dynamic_confidence.dynamic_confidence}`} name={`confidence_${dynamic_confidence.dynamic_confidence}`} value="1" /> <b> Not sure </b>
               </div> }

                {gobackanser==2 ? 
               <div className="ca_releas4-1">
               <input type="radio" className="somewhat_sure" id={`somewhatsure_${dynamic_confidence.dynamic_confidence}`} name={`confidence_${dynamic_confidence.dynamic_confidence}`} value="2" checked /> <b>Somewhat sure </b>
               </div> : <div className="ca_releas4-1">
               <input type="radio" className="somewhat_sure" id={`somewhatsure_${dynamic_confidence.dynamic_confidence}`} name={`confidence_${dynamic_confidence.dynamic_confidence}`} value="2"  /> <b>Somewhat sure </b>
               </div> }

               {gobackanser==3 ? 
               <div className="ca_releas4-2">
               <input type="radio" className="very_sure" id={`verysure_${dynamic_confidence.dynamic_confidence}`} name={`confidence_${dynamic_confidence.dynamic_confidence}`} value="3" checked /> <b>Very sure</b> <br />
               </div>
               : <div className="ca_releas4-2">
               <input type="radio" className="very_sure" id={`verysure_${dynamic_confidence.dynamic_confidence}`} name={`confidence_${dynamic_confidence.dynamic_confidence}`} value="3"  /> <b>Very sure</b> <br />
               </div>}
               <div className="error_reg" style={{display:"none"}} id={`errorconfident_${dynamic_confidence.dynamic_confidence}`}>
               <font color="#cc0000">You should select either one from the given below options.</font>
               </div>
            </div>
        );
        }
        else
        {
            return (
                <div className="lr-gray-box test">
                    <h4>How confident are you about this answer ?</h4>
                    
                    {confidence_result==1 ?
                    <div className="ca_releas4"> 
                   <input type="radio" className="not_sure" id={`notsure_${dynamic_confidence.dynamic_confidence}`} name={`confidence_${dynamic_confidence.dynamic_confidence}`} value="1"  disabled="disabled" checked /> <b> Not sure </b>
                    <img src={process.env.PUBLIC_URL + '/images/tick.gif'} className={`confidence_${dynamic_confidence.dynamic_confidence}`} alt="" border="0" /> 
                   </div>
                    : <div className="ca_releas4"> 
                   <input type="radio" className="not_sure" id={`notsure_${dynamic_confidence.dynamic_confidence}`} name={`confidence_${dynamic_confidence.dynamic_confidence}`} value="1"  disabled="disabled" /> <b> Not sure </b>
                   </div>}

                   
                   {confidence_result==2 ?    
                   <div className="ca_releas4-1">
                   <input type="radio" className="somewhat_sure" id={`somewhatsure_${dynamic_confidence.dynamic_confidence}`} name={`confidence_${dynamic_confidence.dynamic_confidence}`} value="2" disabled="disabled" checked /> <b>Somewhat sure </b>
                    <img src={process.env.PUBLIC_URL + '/images/tick.gif'} className={`confidence_${dynamic_confidence.dynamic_confidence}`} alt="" border="0" /> 
                   </div> :<div className="ca_releas4-1">
                   <input type="radio" className="somewhat_sure" id={`somewhatsure_${dynamic_confidence.dynamic_confidence}`} name={`confidence_${dynamic_confidence.dynamic_confidence}`} value="2"  disabled="disabled" /> <b>Somewhat sure </b>
                   </div>}

                   

                   {confidence_result==3 ?  
                   <div className="ca_releas4-2">
                   <input type="radio" className="very_sure" id={`verysure_${dynamic_confidence.dynamic_confidence}`} name={`confidence_${dynamic_confidence.dynamic_confidence}`} value="3" disabled="disabled" checked /> <b>Very sure</b> 
                   <img src={process.env.PUBLIC_URL + '/images/tick.gif'} className={`confidence_${dynamic_confidence.dynamic_confidence}`} alt="" border="0" /> 
                   </div> : <div className="ca_releas4-2">
                   <input type="radio" className="very_sure" id={`verysure_${dynamic_confidence.dynamic_confidence}`} name={`confidence_${dynamic_confidence.dynamic_confidence}`} value="3" disabled="disabled" /> <b>Very sure</b> <br />
                   </div> }
                   

                   
                </div>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Confidencemeter.js